import React, { useState, useEffect } from "react";
import styles from "../../assets/scss/Billing/Calculate.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../Components/Common/Pagination";
import { useGetPayableCustomerJournalsQuery } from "../../slices/admin/admin";

const PayableViewLadgerId = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const customerId = searchParams.get("id");
    const journalId = searchParams.get("journalId");
    const mode = searchParams.get("mode");

    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [paginatedItems, setPaginatedItems] = useState([]);

    const { data, isLoading, isError } = useGetPayableCustomerJournalsQuery({
        customerId,
        offset: currentPage,
        limit,
        journalId,
    });

    const journal = data?.journals?.[0] || {};
    const items = journal?.billItems || [];
    const totalPages = Math.ceil(items.length / limit) || 1;

    useEffect(() => {
        const startIndex = (currentPage - 1) * limit;
        const endIndex = startIndex + limit;
        setPaginatedItems(items.slice(startIndex, endIndex));
    }, [currentPage, limit, items]);

    const customerName = data?.customerDetails?.firstName || journal?.storeId?.storeName || "N/A";
    const customerPhone = data?.customerDetails?.phone || journal?.storeId?.userId?.phone || "N/A";
    const paymentMethod = journal?.paymentMethod || "N/A";

    const commissionType = journal?.billingInfo?.saleCommission || "-";
    const commissionValue = journal?.billingInfo?.percentage || 0;
    const commissionAmount = journal?.billingInfo?.commissionAmount || 0;
    const handleCharge = journal?.billingInfo?.handleCharge || 0;
    const logisticCharge = journal?.billingInfo?.logisticCharge || 0;
    const overallTotal = journal?.billingInfo?.totalAmount || 0;

    const handleClose = () => {
        navigate(`/dashboard/PayableViewLadger?id=${customerId}&mode=${mode}`);
    };

    return (
        <div className={styles.calculateContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>View Payable Billing Details </h2>
                <span onClick={handleClose} className={styles.closeIcon}>
                    ✕
                </span>
            </div>

            <div className={styles.padding}>
                {isLoading ? (
                    <p style={{ textAlign: "center" }}>Loading...</p>
                ) : isError ? (
                    <p style={{ textAlign: "center", color: "red" }}>Failed to load billing details</p>
                ) : (
                    <>
                        {/* Customer Info */}
                        {/* <div className={styles.formSection}>
                            <div className={styles.inputRow}>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Customer Name</label>
                                    <input className={styles.input} type="text" value={customerName} disabled />
                                </div>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Phone Number</label>
                                    <input className={styles.input} type="text" value={customerPhone} disabled />
                                </div>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Payment Type</label>
                                    <input className={styles.input} type="text" value={paymentMethod} disabled />
                                </div>
                            </div>
                        </div> */}
                        <div className={styles.ownerBox}>
                            <p>
                                <strong>Item Owner :</strong> {customerName || "-"}
                            </p>
                            <p>
                                <strong>Phone No :</strong> {customerPhone || "-"}
                            </p>
                            <p>
                                <strong>Payment Method :</strong> {paymentMethod || "-"}
                            </p>
                        </div>

                        {/* Items Table */}
                        <div className={styles.itemsSection}>
                            <div className={styles.tableWrapper}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th>Price</th>
                                            <th>Qty</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedItems.map((i) => (
                                            <tr key={i._id}>
                                                <td>{i.productName || i.itemId?.productName}</td>
                                                <td>₹{i.price}</td>
                                                <td>{i.productQuantity || i.productCount || i.itemId?.overallQuantity}</td>
                                                <td>₹{i.totalPrice}</td>
                                            </tr>
                                        ))}
                                        {paginatedItems.length === 0 && (
                                            <tr>
                                                <td colSpan={4} className={styles.noData}>No items found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {items.length > 0 && (
                                <div className={styles.paginationWrapper}>
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={setCurrentPage}
                                    />
                                    <select
                                        className={styles.inputsbtn}
                                        value={limit}
                                        onChange={(e) => {
                                            setLimit(Number(e.target.value));
                                            setCurrentPage(1);
                                        }}
                                    >
                                        <option value={10}>10 rows</option>
                                        <option value={25}>25 rows</option>
                                        <option value={50}>50 rows</option>
                                    </select>
                                </div>
                            )}
                        </div>

                        {/* Charges Section */}
                        <div className={styles.chargesSection}>
                            <div className={styles.inputRows}>
                                <div className={styles.inputGroups}>
                                    <label className={styles.inputLabel}>Commission Type : </label>
                                    <h2 className={styles.inputones}>{commissionType}</h2>
                                </div>

                                {commissionType === "percentage" && (
                                    <div className={styles.inputGroups}>
                                        <label className={styles.inputLabel}>Enter % : </label>
                                        <h2 className={styles.inputones}>{commissionValue}%</h2>
                                    </div>
                                )}

                                <div className={styles.inputGroups}>
                                    <label className={styles.inputLabel}>Commission Amount : </label>
                                    <h2 className={styles.inputones}>₹ {commissionAmount}</h2>
                                </div>

                                <div className={styles.inputGroups}>
                                    <label className={styles.inputLabel}>Handling Charge : </label>
                                    <h2 className={styles.inputones}>₹ {handleCharge}</h2>
                                </div>
                            </div>

                            <div className={styles.inputRows}>
                                <div className={styles.inputGroups}>
                                    <label className={styles.inputLabel}>TransportCharge : </label>
                                    <h2 className={styles.inputones}>₹ {logisticCharge}</h2>
                                </div>
                                <div className={styles.inputGroups}>
                                    <label className={styles.inputLabel}>Overall Total : </label>
                                    <h2 className={styles.inputones}>₹ {overallTotal}</h2>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className={styles.footerButtons}>
                            <button className={styles.cancelBtn} onClick={handleClose}>
                                Cancel
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default PayableViewLadgerId;
